export default __webpack_public_path__ + "static/media/GuideCv.c224b1f0.jpg";